import * as React from 'react'
import MenuItem from '@mui/material/MenuItem'
import { Box, FormControl, InputLabel, Select } from '@mui/material'
import { SelectReportTypePropType } from './projectQAReportTypes'
import { style } from './ projectQAReportStyles'
import { useState } from 'react'

const SelectReportType = ({selectType,setSelectType}:SelectReportTypePropType) => {
  const [open,setOpen] = useState(false)

  const handleSelectChange = (event: { target: { value: React.SetStateAction<string> } }) => {
    setSelectType(event.target.value)
  }

  return (
    <Box sx={style.SelectReportTypeBoxStyle}>
      <FormControl fullWidth>
        <InputLabel id='demo-simple-select-label'>Report Type</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='demo-simple-select'
          displayEmpty
          value={selectType}
          label='Report Type'
          onChange={handleSelectChange}
          sx={style.selectReportTypeStyle}
          open={open}
          onClick={()=>setOpen((prev)=>!prev)}
          onOpen={()=>window.addEventListener('scroll',()=>setOpen(false))}
          onClose={()=>window.removeEventListener('scroll',()=>setOpen(false))}
        >
          <MenuItem value='project-wise'>Project Wise</MenuItem>
          <MenuItem value='employee-wise'>Employee Wise</MenuItem>
        </Select>
      </FormControl>
    </Box>
  )
}

export default SelectReportType
